import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing sign-in token.");
      return;
    }
    api
      .post("/auth/magic/verify", { token })
      .then(({ data }) => {
        setUser(data);
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => setError(formatApiError(err.response?.data?.detail)));
  }, [params, navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0a0c] px-4 text-center">
      {error ? (
        <div data-testid="verify-error" className="max-w-sm space-y-4">
          <XCircle className="mx-auto h-12 w-12 text-rose-500" />
          <p className="text-white">{error}</p>
          <Button onClick={() => navigate("/login")} className="bg-[#ff2a5f] text-white hover:bg-[#e01f50]">
            Back to sign in
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          <Loader2 className="mx-auto h-10 w-10 animate-spin text-[#ff2a5f]" />
          <p className="text-zinc-400">Signing you in…</p>
        </div>
      )}
    </div>
  );
}
